import type { CompareExpression, CompareOperator } from '@tsagko/label-contracts'
import { useCmdK } from '../shell/CmdKContext'

interface FilterRowProps {
  compare: CompareExpression
  onChange: (next: CompareExpression) => void
  onRemove: () => void
}

const OPERATORS: CompareOperator[] = [
  '=',
  '!=',
  '<',
  '<=',
  '>',
  '>=',
  'contains',
  'startsWith',
  'endsWith',
  'in',
  'exists',
  'matches',
]

export function FilterRow({ compare, onChange, onRemove }: FilterRowProps) {
  const { open } = useCmdK()
  const valueText = typeof compare.value === 'string' ? compare.value : JSON.stringify(compare.value)

  return (
    <div
      data-testid="rc-filter-row"
      className="flex flex-wrap items-center gap-2 rounded border border-stone-200 bg-stone-50 px-2 py-1.5 dark:border-stone-800 dark:bg-stone-950"
    >
      <div className="flex flex-1 items-center gap-1 min-w-0">
        <input
          data-testid="rc-filter-field"
          value={compare.field}
          onChange={e => onChange({ ...compare, field: e.target.value })}
          placeholder="field key"
          className="w-32 rounded border border-stone-300 bg-white px-2 py-1 font-mono text-xs dark:border-stone-700 dark:bg-stone-900"
        />
        <button
          type="button"
          data-testid="rc-filter-cmdk"
          onClick={() =>
            open(fieldKey => onChange({ ...compare, field: fieldKey }))
          }
          className="rounded border border-stone-300 px-1.5 py-1 text-[10px] text-stone-600 hover:bg-stone-100 dark:border-stone-700 dark:text-stone-400 dark:hover:bg-stone-800"
          title="Pick field (⌘K)"
        >
          ⌘K
        </button>
      </div>
      <select
        data-testid="rc-operator"
        value={compare.operator}
        onChange={e =>
          onChange({ ...compare, operator: e.target.value as CompareOperator })
        }
        className="rounded border border-stone-300 bg-white px-2 py-1 text-xs dark:border-stone-700 dark:bg-stone-900"
      >
        {OPERATORS.map(op => (
          <option key={op} value={op}>
            {op}
          </option>
        ))}
      </select>
      {compare.operator !== 'exists' && (
        <input
          value={valueText}
          onChange={e => onChange({ ...compare, value: e.target.value })}
          placeholder="value"
          className="w-40 rounded border border-stone-300 bg-white px-2 py-1 text-xs dark:border-stone-700 dark:bg-stone-900"
        />
      )}
      <button
        type="button"
        onClick={onRemove}
        aria-label="Remove condition"
        className="rounded px-1 text-xs text-rose-600 hover:underline"
      >
        ✕
      </button>
    </div>
  )
}
